import type { ComponentProps, PropsWithChildren } from 'react'
import { MainWrapper } from '@/src/common/wrappers/MainWrapper'
import { NavigationSection } from '@/src/common/components/NavigationSection'
import { useMainWrapperPadding } from '@/src/common/wrappers/MainWrapper'
import { mesaColorNames } from '@/src/common/theme'

/** for wrapping screens that don't live within the `/main/(tabs)` layout */
export function StandaloneWrapper({
  children,
  screen,
  title,
  profileProps,
  hideBackButton,
  onBackPress,
  contentContainerStyle,
  showProfile,
}: PropsWithChildren &
  Pick<
    ComponentProps<typeof MainWrapper>,
    'screen' | 'profileProps' | 'contentContainerStyle' | 'showProfile'
  > &
  Pick<ComponentProps<typeof NavigationSection>, 'title' | 'hideBackButton' | 'onBackPress'>) {
  const mainWrapperPadding = useMainWrapperPadding()
  return (
    <MainWrapper
      screen={screen}
      showProfile={showProfile}
      profileProps={profileProps}
      scrollViewProps={{
        style: {
          paddingTop: 0,
          backgroundColor: mesaColorNames['Mesa - Brand/Secondary #223843'],
        },
      }}
      contentContainerStyle={[{ paddingTop: mainWrapperPadding }, contentContainerStyle]}
      insetTopProps={{
        style: { backgroundColor: mesaColorNames['Mesa - Brand/Secondary #223843'] },
      }}
      bodyProps={{ style: { flexDirection: 'column', flexWrap: 'nowrap' } }}
    >
      <NavigationSection
        title={title}
        titleStyles={{ color: mesaColorNames['Mesa - Brand/White #FFFFFF'] }}
        chevronColor={mesaColorNames['Mesa - Brand/White #FFFFFF']}
        hideBackButton={hideBackButton}
        onBackPress={onBackPress}
      />
      {children}
    </MainWrapper>
  )
}
